import { useApiClient } from '@/composables/useApiClient'
import type {
  IAiCreditBalanceResponse,
  IAiTenantSummaryResponse,
} from '@/services/ai/interfaces/ai-credit.interface'

export const useAiService = () => {
  const privateApi = useApiClient(true)

  const getPlatformCredits = async () => {
    return privateApi.get<IAiCreditBalanceResponse>('/ai/credits')
  }

  const getTenantSummary = async () => {
    return privateApi.get<IAiTenantSummaryResponse>('/ai/summary')
  }

  return {
    getPlatformCredits,
    getTenantSummary,
  }
}
